module.exports = __webpack_public_path__ + "static/img-cherry-blossom-91e8a16d46db405fcfb8bb4841579551.jpg";